// extracted by mini-css-extract-plugin
export default {"root":"LearnerEmailBadge_root__FaZgf","emailContainer":"LearnerEmailBadge_emailContainer__2Q3jr"};